import React, { Fragment } from 'react'
import ListBox from 'components/ListBox'
import ListRow from 'components/ListRow'
import PageHeader from 'components/PageHeader'
import RouteAdminFeaturesUsersIndexQuery from './index.query'
import State from 'components/State'
import { Input, UserIcon } from 'stylist'
import { Query } from 'react-apollo'

const RouteAdminFeaturesUsersIndex = ({ match: { url } }) => (
  <State
    initial={{ search: '' }}
    render={({ state: { search }, setState }) => (
      <Query
        query={RouteAdminFeaturesUsersIndexQuery}
        variables={{ userCount: 9999, search }}
      >
        {({ loading, data: { users } }) => (
          <Fragment>
            <PageHeader columns="auto 1fr 350px">
              <PageHeader.Icon>
                <UserIcon />
              </PageHeader.Icon>
              <PageHeader.Title>Users</PageHeader.Title>
              <Input
                type="text"
                placeholder="Search..."
                onChange={e => setState({ search: e.target.value })}
              />
            </PageHeader>
            <article>
              <ListBox>
                {loading ? (
                  <ListBox.Loader />
                ) : (
                  users.edges.map(({ node: user }) => (
                    <ListBox.Item hover key={user.id}>
                      <ListRow templateColumns="minmax(120px, auto) 1fr">
                        <ListRow.Cell>
                          <ListRow.TitleLink to={`${url}/${user.id}`}>
                            <strong>
                              {user.firstName} {user.lastName}
                            </strong>
                          </ListRow.TitleLink>
                        </ListRow.Cell>
                        <ListRow.Cell>({user.email})</ListRow.Cell>
                      </ListRow>
                    </ListBox.Item>
                  ))
                )}
              </ListBox>
            </article>
          </Fragment>
        )}
      </Query>
    )}
  />
)

export default RouteAdminFeaturesUsersIndex



// WEBPACK FOOTER //
// ./src/routes/admin/features/users/index.js